// Copyright © 2025 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get, has, uniqBy, cloneDeep } from 'lodash';

import * as Constants from '../../constants';
import { reduceReducers, getErrors as processErrors } from '../util';
import apiProductsReducer from './apiProductsReducer';

const initialState = {
  isLoading: true,
  errors: [],
  organizations1: {},
  organizations: [],
  organizationsCount: 0,
  applicationDetails: {
    apiIds: [],
    apiApiPlanIds: [],
    apiGroupIds: [],
    customFieldValues: {},
    oauthType: 'PUBLIC',
  },
  applicationNameUnique: { d: { result: true } },
  customFields: [],
  selectedApis: [],
  availableApis: [],
  availableApisCount: 0,
  availableApps: [],
  availableAppsCount: 0,
  availableOrgs: [],
  availableOrgsCount: 0,
  apiEula: {},
  apiGroupEulas: [],
  selectedApiGroups: [],
  availableApiGroups1: {},
  availableApiGroups: [],
  availableApiGroupsCount: 0,
  availableApiPlans: {},
  isApplicationSaveSuccess: false,
  tenantInfos: {},
  proxyErrors: [],
  proxies: [],
  apiKeyProxies: [],
  singleApplication: {},
  allApis: [],
  allApps: [],
  allApiPlans: [],
  updateApplicationStatus: '',
  deleteApplicationStatus: Constants.NONE,

  createdKey: null,
  createKeyStatus: '',
  updateKeyStatus: '',
  deleteKeyStatus: '',
  deleteKeyErrors: [],
  isUniqueKey: '',
  keys: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  applicationAPIProducts: {},
  apis: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  isApiUpdateSuccess: false,
  isProductApiUpdateSuccess: false,
  productApiErrors: [],
  isProductApiError: false,
  isError: false,
  productApis: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  keyStores: [],
  apiKeyKeyStores: [],
  keyStoreErrors: [],
  appProductTiers: [],
};

const updateProxyErrors = (arr = [], obj) => {
  const tempArr = cloneDeep(arr);
  const index = arr.findIndex((e) => (e.proxyUuid === obj.proxyUuid && e.apiKey === obj.apiKey));
  if (index === -1) {
    tempArr.push(obj);
  } else {
    tempArr[index] = obj;
  }
  return tempArr;
};

const updateKeyStoreErrors = (arr = [], obj) => {
  const tempArr = cloneDeep(arr);
  const index = arr.findIndex((e) =>
    (e.keyStoreUuid === obj.keyStoreUuid && e.apiKey === obj.apiKey));
  if (index === -1) {
    tempArr.push(obj);
  } else {
    tempArr[index] = obj;
  }
  return tempArr;
};

const updateApiKeyProxies = (arr = [], obj) => {
  const tempArr = cloneDeep(arr);
  const index = arr.findIndex((e) => e.key === obj.key);
  if (index === -1) {
    tempArr.push(obj);
  } else {
    tempArr[index] = obj;
  }
  return tempArr;
};

const updateApiKeyStores = (arr = [], obj) => {
  const tempArr = cloneDeep(arr);
  const index = arr.findIndex((e) => e.key === obj.key);
  if (index === -1) {
    tempArr.push(obj);
  } else {
    tempArr[index] = obj;
  }
  return tempArr;
};

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.APPLICATION_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case Constants.APPLICATION_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        applications: action.payload,
      };
    case Constants.APPLICATION_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        isListError: true,
      };
    case Constants.APPLICATION_LOADING:
      return {
        ...state,
        apiEula: {},
        apiGroupEulas: [],
        isLoading: action.isLoading,
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APP_RESET:
      return {
        ...state,
        errors: [],
      };
    case Constants.APPLICATION_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_GRANULAR_CREATE_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          singleApplication: action.payload,
          isAddApplicationSuccess: true,
      };
      case Constants.APPLICATION_GRANULAR_UPDATE_REQUEST:
        return {
          ...state,
          isError: false,
          isLoading: action.isLoading,
          errors: [],
          isUpdateApplicationError: false,
          isUpdateApplicationSuccess: false,
      };
      case Constants.APPLICATION_GRANULAR_UPDATE_SUCCESS:
        return {
          ...state,
          isError: false,
          isLoading: action.isLoading,
          errors: [],
          isUpdateApplicationSuccess: true,
          isUpdateApplicationError: false,
      };
      case Constants.APPLICATION_GRANULAR_UPDATE_ERROR:
        return {
          ...state,
          isError: true,
          isLoading: action.isLoading,
          errors: action.payload,
          isUpdateApplicationError: true,
          isUpdateApplicationSuccess: false,
      };
      case Constants.APPLICATION_PUBLISH_REQUEST:
        return {
          ...state,
          isLoading: action.isLoading,
          publishResult: {
            result:'CALLING',
          },
        };
      case Constants.APPLICATION_PUBLISH_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          publishResult: {
            result: 'SUCCESS',
          },
        };
      case Constants.APPLICATION_PUBLISH_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          publishResult : {
            result:'FAIL',
            errors: action.payload,
          },
        };
      case Constants.APPLICATION_CUSTOM_FIELDS_UPDATE_REQUEST:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          isUpdateApplicationCustomFieldsSuccess: false,
          isUpdateApplicationCustomFieldsError: false,
      };
    case Constants.APPLICATION_CUSTOM_FIELDS_UPDATE_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          isUpdateApplicationCustomFieldsSuccess: true,
      };
    case Constants.APPLICATION_CUSTOM_FIELDS_UPDATE_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          isUpdateApplicationCustomFieldsError: true,
      };
    case Constants.APPLICATION_SECRET_UPDATE_SUCCESS: {
      return {
        ...state,
        isApplicationSecretSaveSuccess: true,
      };
    }
    case Constants.APPLICATION_ORGANIZATIONS_GET_SUCCESS: {
      const organizations1 = state.organizations1;
      const payload = action.payload;
      if (has(payload, 'results') && has(organizations1, 'results')) {
        payload.results = [...organizations1.results, ...action.payload.results];
      }
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        organizations1: payload,
        organizations: get(action, 'payload.results'),
        organizationsCount: get(action, 'payload.totalElements'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.APPLICATION_NAME_UNIQUE_REQUEST:
      return {
        ...state,
        isLoading: action.isLoading,
        applicationNameUnique: undefined,
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_NAME_UNIQUE_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        applicationNameUnique: action.payload,
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_CUSTOM_FIELDS_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        customFields: get(action, 'payload.results'),
      };
    case Constants.APPLICATION_ASSIGNED_APIS_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        appAssignedAPIs: action.payload,
      };
    case Constants.APPLICATION_ASSIGNED_APIS_GET_ERROR:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: action.payload,
        appAssignedAPIsGetFailure: true,
      };
    case Constants.APPLICATION_ASSIGNED_APIS_UPDATE_REQUEST:
      return {
        ...state,
        appAssignedAPIsUpdateResult: 'UPDATING',
      };
    case Constants.APPLICATION_ASSIGNED_APIS_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        appAssignedAPIsUpdateResult: 'SUCCESS',
      };
    case Constants.APPLICATION_ASSIGNED_APIS_UPDATE_ERROR:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: action.payload,
        appAssignedAPIsUpdateResult: 'FAILURE',
      };
      case Constants.APPLICATION_ASSIGNED_API_PLANS_GET_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          appAssignedApiPlans: action.payload,
        };
      case Constants.APPLICATION_ASSIGNED_API_PLANS_GET_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: action.payload,
          appAssignedApiPlansGetFailure: true,
        };
      case Constants.APPLICATION_ASSIGNED_API_PLANS_UPDATE_REQUEST:
        return {
          ...state,
          appAssignedApiPlansUpdateResult: 'UPDATING',
        };

      case Constants.APPLICATION_ASSIGNED_API_PLANS_UPDATE_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          appAssignedApiPlansUpdateResult: 'SUCCESS',
        };
      case Constants.APPLICATION_ASSIGNED_API_PLANS_UPDATE_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: action.payload,
          appAssignedApiPlansUpdateResult: 'FAILURE',
        };
      case Constants.APPLICATION_GET_REQUEST_STATUS_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          appRequestStatus: action.payload,
        };
      case Constants.APPLICATION_GET_REQUEST_STATUS_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: action.payload,
        };
      case Constants.APPLICATION_GET_REQUEST_STATUS_REQUEST:
        return {
          ...state,
          isLoading: action.isLoading,
        };
      case Constants.APPLICATION_ASSIGNED_API_GROUPS_GET_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          appAssignedAPIGroups: action.payload,
        };
      case Constants.APPLICATION_ASSIGNED_API_GROUPS_GET_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: action.payload,
          appAssignedAPIGroupsGetFailure: true,
        };
      case Constants.APPLICATION_ASSIGNED_API_GROUPS_UPDATE_REQUEST:
        return {
          ...state,
          appAssignedAPIGroupsUpdateResult: '',
        };
      case Constants.APPLICATION_ASSIGNED_API_GROUPS_UPDATE_SUCCESS:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: [],
          appAssignedAPIGroupsUpdateResult: 'SUCCESS',
        };
      case Constants.APPLICATION_ASSIGNED_API_GROUPS_UPDATE_ERROR:
        return {
          ...state,
          isLoading: action.isLoading,
          errors: action.payload,
          appAssignedAPIGroupsUpdateResult: 'FAILURE',
        };

    case Constants.APPLICATION_AVAILABLE_APIS_GET_SUCCESS: {
      let availableApis = get(action, 'payload.results');
      /* if page number is valid and > 0, add the apis from
      response to already pulled apis. else clear it.
      */
      if (Number.isInteger(action.page) && (action.page > 0)) {
        const cachedAPIs = state.availableApis;
        availableApis = [...cachedAPIs, ...availableApis];
      }
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        availableApis,
        availableApisCount: get(action, 'payload.totalElements'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.APPLICATION_AVAILABLE_APPS_GET_SUCCESS: {
      let availableApps = get(action, 'payload.results');
      /* if page number is valid and > 0, add the apps from
      response to already pulled apps. else clear it.
      */
      if (Number.isInteger(action.page) && (action.page > 0)) {
        const cachedAPPs = state.availableApps;
        availableApps = [...cachedAPPs, ...availableApps];
      }
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        availableApps,
        availableAppsCount: get(action, 'payload.totalElements'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.APPLICATION_AVAILABLE_ORGS_GET_SUCCESS: {
      let availableOrgs = get(action, 'payload.results');
      /* if page number is valid and > 0, add the apps from
      response to already pulled apps. else clear it.
      */
      if (Number.isInteger(action.page) && (action.page > 0)) {
        const cachedORGs = state.availableOrgs;
        availableOrgs = [...cachedORGs, ...availableOrgs];
      }
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        availableOrgs,
        availableOrgsCount: get(action, 'payload.totalElements'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.APPLICATION_API_EULA_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        apiEula: get(action, 'payload'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_GENERATE_SECRET_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        secret: get(action, 'payload.d.result'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_CUSTOM_FIELD_VALUES_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        appCustomFieldValues: get(action, 'payload'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_SELECTED_API_GROUPS_GET_SUCCESS:
      return {
        ...state,
        errors: [],
        selectedApiGroups: uniqBy(
          get(action, 'payload.d.results'),
          ({ uuid }) => (uuid),
        ),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_AVAILABLE_API_GROUPS_GET_SUCCESS: {
      const availableApiGroups1 = state.availableApiGroups1;
      const payload = action.payload;
      if (has(action, 'payload.results') && has(availableApiGroups1, 'results') && action.page !== 0) {
        payload.results = [...availableApiGroups1.results, ...action.payload.results];
      }
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        availableApiGroups1: payload,
        availableApiGroups: get(action, 'payload.results'),
        availableApiGroupsCount: get(action, 'payload.totalElements'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.APPLICATION_API_GROUP_EULAS_GET_SUCCESS:
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        apiGroupEulas: get(action, 'payload.d.results'),
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    case Constants.APPLICATION_AVAILABLE_API_PLANS_GET_SUCCESS: {
      const { availableApiPlans } = state;
      return {
        ...state,
        isLoading: action.isLoading,
        errors: [],
        availableApiPlans: {
          ...availableApiPlans,
          ...action.payload,
        },
        isApplicationSaveSuccess: false,
        isApplicationSecretSaveSuccess: false,
      };
    }
    case Constants.PROXIES_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        proxies: [],
      };
    }
    case Constants.PROXIES_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        proxies: action.payload,
      };
    }
    case Constants.API_KEY_PROXIES_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        apiKeyProxies: updateApiKeyProxies(get(state, 'apiKeyProxies'), action.payload),
      };
    }
    case Constants.APPLICATION_ALL_KEYS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        keys: action.payload,
        deleteKeyStatus: '',
      };
    }
    case Constants.APPLICATION_ALL_KEYS_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    }
    case Constants.APPLICATION_SINGLE_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        singleApplication: action.payload,
      };
    }
    case Constants.APPLICATION_SINGLE_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        getAppErrors: action.payload,

      };
    }
    case Constants.APPLICATION_API_PLANS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        allApiPlans: action.payload,
      };
    }
    case Constants.APPLICATION_STATUS_UPDATE_RESET: {
      return {
        ...state,
        updateApplicationStatus: '',
      };
    }
    case Constants.APPLICATION_STATUS_UPDATE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        updateApplicationStatus: Constants.FAIL,
      };
    }
    case Constants.APPLICATION_DELETE_RESET: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        deleteApplicationStatus: Constants.NONE,
      };
    }
    case Constants.APPLICATION_DELETE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        deleteApplicationStatus: Constants.SUCCESS,
      };
    }
    case Constants.APPLICATION_DELETE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        deleteApplicationStatus: Constants.FAIL,
      };
    }
    case Constants.API_KEY_DEPLOY_SUCCESS:
    case Constants.API_KEY_REDEPLOY_SUCCESS:
    case Constants.API_KEY_UNDEPLOY_SUCCESS: {
      const obj = {
        apiKey: get(action.payload, 'apiKey'),
        proxyUuid: get(action.payload, 'proxyUuid'),
        errorMessage: '',
        validation: Constants.SUCCESS,
      };
      return {
        ...state,
        proxyErrors: updateProxyErrors(get(state, 'proxyErrors'), obj),
      };
    }
    case Constants.API_KEY_DEPLOY_ERROR:
    case Constants.API_KEY_REDEPLOY_ERROR:
    case Constants.API_KEY_UNDEPLOY_ERROR: {
      const obj = {
        apiKey: get(action.payload, 'apiKey'),
        proxyUuid: get(action.payload, 'proxyUuid'),
        errorMessage: get(action.payload, 'errorMessage'),
        validation: Constants.FAIL,
      };
      return {
        ...state,
        proxyErrors: updateProxyErrors(get(state, 'proxyErrors'), obj),
      };
    }
    case Constants.API_KEY_PROXIES_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    }
    case Constants.KEY_NAME_UNIQUE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        isUniqueKey: action.payload,
      };
    }
    case Constants.KEY_NAME_UNIQUE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        isUniqueKey: '',
      };
    }
    case Constants.KEY_STATUS_RESET: {
      return {
        ...state,
        errors: [],
        deleteKeyStatus: '',
        createKeyStatus: '',
        updateKeyStatus: '',
      };
    }
    case Constants.KEY_CREATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        createKeyStatus: Constants.SUCCESS,
        createdKey: action.payload,
      };
    }
    case Constants.KEY_CREATE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        createKeyStatus: Constants.FAIL,
        createdKey: null,
      };
    }
    case Constants.KEY_UPDATE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        updateKeyStatus: Constants.SUCCESS,
        createdKey: null,
      };
    }
    case Constants.KEY_UPDATE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        updateKeyStatus: Constants.FAIL,
        createdKey: null,
      };
    }
    case Constants.KEY_REGENERATE_SECRET_REQUEST: {
      return {
        ...state,
        isLoading: true,
        regeneratedSecretDetails: {},
        errors: [],
        updateKeyStatus: '',
        regenerateSecretStatus: Constants.NONE,
      };
    }
    case Constants.KEY_REGENERATE_SECRET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        regeneratedSecretDetails: action.payload,
        errors: [],
        updateKeyStatus: Constants.SUCCESS,
        regenerateSecretStatus: Constants.SUCCESS,
      };
    }
    case Constants.KEY_REGENERATE_SECRET_ERROR: {
      return {
        ...state,
        isLoading: false,
        regeneratedSecretDetails: {},
        errors: action.payload,
        updateKeyStatus: Constants.FAIL,
        regenerateSecretStatus: Constants.FAIL,
      };
    }
    case Constants.KEY_DELETE_STATUS_RESET: {
      return {
        ...state,
        errors: [],
        deleteKeyErrors: [],
      };
    }
    case Constants.KEY_DELETE_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        deleteKeyErrors: [],
        createKeyStatus: '',
        updateKeyStatus: '',
        deleteKeyStatus: Constants.SUCCESS,
        createdKey: null,
      };
    }
    case Constants.KEY_DELETE_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        deleteKeyErrors: action.payload,
        createKeyStatus: '',
        updateKeyStatus: '',
        deleteKeyStatus: Constants.FAIL,
        createdKey: null,
      };
    }
    case Constants.FETCH_API_PLAN_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        singleApiPlan: action.payload,
      };
    }
    case Constants.FETCH_API_GROUP_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        singleApiGroup: action.payload,
      };
    }
    case Constants.APPLICATION_API_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: [],
        isError: false,
        apis: action.payload,
      };
    case Constants.APPLICATION_API_GET_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.APPLICATION_PRODUCT_API_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: [],
        isError: false,
        productApis: action.payload,
      };
    case Constants.APPLICATION_PRODUCT_API_GET_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
        errors: action.payload,
      };
    case Constants.APPLICATION_APIS_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        errors: [],
        isError: false,
        isApiUpdateSuccess: true,
      };
    case Constants.APPLICATION_APIS_UPDATE_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        isError: true,
        isApiUpdateSuccess: false,
      };
    case Constants.APPLICATION_APIS_UPDATE_RESET:
      return {
        ...state,
        isLoading: false,
        isApiUpdateSuccess: false,
      };
    case Constants.APPLICATION_PRODUCT_API_PATCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        productApiErrors: [],
        isProductApiError: false,
        isProductApiUpdateSuccess: true,
      };
    case Constants.APPLICATION_PRODUCT_API_PATCH_ERROR:
      return {
        ...state,
        isLoading: false,
        productApiErrors: action.payload,
        isProductApiError: true,
        isProductApiUpdateSuccess: false,
      };
    case Constants.APPLICATION_PRODUCT_API_PATCH_RESET:
      return {
        ...state,
        isLoading: false,
        productApiErrors: [],
        isProductApiError: false,
        isProductApiUpdateSuccess: false,
      };
    case Constants.APPLICATION_CERTIFICATE_GET_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        certificateList: action.payload,
        certListGetError: false,
      };
    case Constants.APPLICATION_CERTIFICATE_GET_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        certListGetError: true,
      };
    case Constants.APPLICATION_CERTIFICATE_RESET:
      return {
        ...state,
        isLoading: false,
        certAddStatus: 'RESET',
        certDeleteStatus: 'RESET',
        certValidationErrors: [],
      };
    case Constants.APPLICATION_CERTIFICATE_ADD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        certAddResponse: action.payload,
        certAddStatus: 'SUCCESS',
      }
    case Constants.APPLICATION_CERTIFICATE_ADD_ERROR:
      return {
        ...state,
        isLoading: false,
        certValidationErrors: action.payload,
        certAddStatus: 'ERROR',
      };
    case Constants.APPLICATION_CERTIFICATE_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        certDeleteStatus: 'SUCCESS',
      }
    case Constants.APPLICATION_CERTIFICATE_DELETE_ERROR:
      return {
        ...state,
        isLoading: false,
        certDeleteStatus: 'ERROR',
        certValidationErrors: action.payload,
      };

    case Constants.APP_KEY_STORES_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        keyStores: get(action, 'payload.results') || [],
      };
    }
    case Constants.APP_KEY_STORES_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
        keyStores: [],
      };
    }
    case Constants.API_KEY_STORES_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        apiKeyKeyStores: updateApiKeyStores(get(state, 'apiKeyKeyStores'), action.payload),
      };
    }
    case Constants.API_KEY_STORES_GET_ERROR: {
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    }
    case Constants.API_KEY_STORE_DEPLOY_SUCCESS:
    case Constants.API_KEY_STORE_REDEPLOY_SUCCESS:
    case Constants.API_KEY_STORE_UNDEPLOY_SUCCESS: {
      const obj = {
        apiKey: get(action.payload, 'apiKey'),
        keyStoreUuid: get(action.payload, 'keyStoreUuid'),
        errorMessage: '',
        validation: Constants.SUCCESS,
      };
      return {
        ...state,
        keyStoreErrors: updateKeyStoreErrors(get(state, 'keyStoreErrors'), obj),
      };
    }
    case Constants.API_KEY_STORE_DEPLOY_ERROR:
    case Constants.API_KEY_STORE_REDEPLOY_ERROR:
    case Constants.API_KEY_STORE_UNDEPLOY_ERROR: {
      const obj = {
        apiKey: get(action.payload, 'apiKey'),
        keyStoreUuid: get(action.payload, 'keyStoreUuid'),
        errorMessage: get(action.payload, 'errorMessage'),
        validation: Constants.FAIL,
      };
      return {
        ...state,
        keyStoreErrors: updateKeyStoreErrors(get(state, 'keyStoreErrors'), obj),
      };
    }
    case Constants.APPLICATION_PRODUCT_TIERS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        errors: [],
        appProductTiers: action.payload,
      };
    }
    case Constants.OAUTH_CLIENT_CREATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        oAuthClientCreateStatus: Constants.RESET,
        oAuthClientErrors: [],
      };
    case Constants.OAUTH_CLIENT_CREATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: [],
        createdOAuthClient: action.payload,
        oAuthClientCreateStatus: Constants.SUCCESS,
      };
    case Constants.OAUTH_CLIENT_CREATE_ERROR:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: action.payload,
        oAuthClientCreateStatus: Constants.FAIL,
      };
    case Constants.OAUTH_CLIENT_UPDATE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        oAuthClientUpdateStatus: Constants.RESET,
        oAuthClientErrors: [],
      };
    case Constants.OAUTH_CLIENT_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: [],
        oAuthClientUpdateStatus: Constants.SUCCESS,
      };
    case Constants.OAUTH_CLIENT_UPDATE_ERROR:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: action.payload,
        oAuthClientUpdateStatus: Constants.FAIL,
      };
      case Constants.OAUTH_CLIENT_REGISTER_REQUEST: {
        return {
          ...state,
          isLoading: true,
          regeneratedKeyDetails: {},
          errors: [],
          registerKeyStatus: Constants.RESET,
        };
      }
      case Constants.OAUTH_CLIENT_REGISTER_SUCCESS: {
        return {
          ...state,
          isLoading: false,
          regeneratedKeyDetails: action.payload,
          errors: [],
          registerKeyStatus: Constants.SUCCESS,
        };
      }
      case Constants.OAUTH_CLIENT_REGISTER_ERROR: {
        const errors = processErrors(action.payload);
        return {
          ...state,
          isLoading: false,
          regeneratedKeyDetails: {},
          errors: errors,
          registerKeyStatus: Constants.FAIL,
        };
      }
    case Constants.OAUTH_CLIENT_DELETE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        oAuthclientDeleteStatus: Constants.RESET,
        oAuthClientErrors: [],
      };
    case Constants.OAUTH_CLIENT_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oAuthClient: [],
        oAuthclientDeleteStatus: Constants.SUCCESS,
      };
    case Constants.OAUTH_CLIENT_DELETE_ERROR:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: action.payload,
        oAuthclientDeleteStatus: Constants.FAIL,
      };
    case Constants.OAUTH_CLIENT_GET_ALL_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        oAuthClientErrors: [],
      };
    case Constants.OAUTH_CLIENT_GET_ALL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: [],
        oAuthClients: action.payload,
      };
    case Constants.OAUTH_CLIENT_GET_ALL_ERROR:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: action.payload,
      };
    case Constants.OAUTH_CLIENT_GET_ONE_REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case Constants.OAUTH_CLIENT_GET_ONE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: [],
        oAuthClient: action.payload,
      };
    case Constants.OAUTH_CLIENT_GET_ONE_ERROR:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: action.payload,
      };
    case Constants.CLEAR_OAUTH_CLIENT_DATA:
      return {
        ...state,
        isLoading: false,
        oAuthClientErrors: [],
        oAuthClient: {},
      };
    default:
      return state;
  }
};

export default reduceReducers(applicationReducer, apiProductsReducer);

export const getIsLoading = (state) => get(state, 'application.isLoading');
export const getErrors = (state) => get(state, 'application.errors');
export const getIsError = (state) => get(state, 'application.isError');

export const getIsApplicationNameUnique = (state) => get(state, 'application.applicationNameUnique.d.result');
export const getIsAppNameUnique = (state) => get(state, 'application.applicationNameUnique.result');
export const getApplicationDetails = (state) => get(state, 'application.applicationDetails');
export const getIsSaveApplicationSuccess = state => get(state, 'application.isApplicationSaveSuccess');
export const getIsSaveApplicationSecretSuccess = state => get(state, 'application.isApplicationSecretSaveSuccess');

// TODO: Clean the multiple getters for Organizations
export const getOrganizations1 = (state) => get(state, 'application.organizations1');
export const getOrganizations = (state) => get(state, 'application.organizations');
export const getOrganizationsCount = (state) => get(state, 'application.organizationsCount');

export const getCustomFields = (state) => get(state, 'application.customFields');

export const getSelectedApis = (state) => get(state, 'application.selectedApis');
export const getAvailableApis = (state) => get(state, 'application.availableApis');
export const getAvailableApisCount = (state) => get(state, 'application.availableApisCount');

export const getAvailableApps = (state) => get(state, 'application.availableApps');
export const getAvailableAppsCount = (state) => get(state, 'application.availableAppsCount');

export const getAvailableOrgs = (state) => get(state, 'application.availableOrgs');
export const getAvailableOrgsCount = (state) => get(state, 'application.availableOrgsCount');

export const getApiEula = (state) => get(state, 'application.apiEula');

export const getSelectedApiGroups = (state) => get(state, 'application.selectedApiGroups');

// TODO: Clean the multiple getters for Organizations
export const getAvailableApiGroups1 = (state) => get(state, 'application.availableApiGroups1');
export const getAvailableApiGroups = (state) => get(state, 'application.availableApiGroups');
export const getAvailableApiGroupsCount = (state) => get(state, 'application.availableApiGroupsCount');
export const getIsListError = (state) => get(state, 'application.isListError');
export const getApplicationsListTotalPages = (state) => get(state, 'application.applications.totalPages');
export const getApplicationsListTotalElements = (state) => get(state, 'application.applications.totalElements');
export const getApplicationsListResults = (state) => get(state, 'application.applications.results');

export const getApiGroupEulas = (state) => get(state, 'application.apiGroupEulas');

export const getAvailableApiPlans = (state) => get(state, 'application.availableApiPlans');

export const getSecret = (state) => get(state, 'application.secret');
export const getTenantInfos = (state) => get(state, 'application.tenantInfos');

export const getProxyErrors = (state) => get(state, 'application.proxyErrors');
export const getProxies = (state) => get(state, 'application.proxies');
export const getProxiesByApiKey = (state) => get(state, 'application.apiKeyProxies');

export const getKeyStoreErrors = (state) => get(state, 'application.keyStoreErrors');
export const getKeyStores = (state) => get(state, 'application.keyStores');
export const getKeyStoresByApiKey = (state) => get(state, 'application.apiKeyKeyStores');

export const getIsUniqueKey = (state) => get(state, 'application.isUniqueKey');
export const getCreateKeyStatus = (state) => get(state, 'application.createKeyStatus');
export const getUpdateKeyStatus = (state) => get(state, 'application.updateKeyStatus');
export const getRegerateSecretStatus = (state) => get(state, 'application.regenerateSecretStatus');
export const getRegisterKeyStatus = (state) => get(state, 'application.registerKeyStatus');
export const getRegisterKeyError = (state) => get(state, 'application.errors');
export const getRegisteredKeyDetails = (state) => get(state, 'application.regeneratedKeyDetails');
export const getRegeneratedSecretDetails = (state) => get(state, 'application.regeneratedSecretDetails');
export const getDeleteKeyStatus = (state) => get(state, 'application.deleteKeyStatus');

export const getAllApis = (state) => get(state, 'application.allApis');
export const getAllApps = (state) => get(state, 'application.allApps');
export const getAllApiPlans = (state) => get(state, 'application.allApiPlans');
export const getSingleApplication = (state) => get(state, 'application.singleApplication');
export const getSingleApplicationErrors = (state) => get(state, 'application.getAppErrors');
export const getUpdateApplicationStatus = state => get(state, 'application.updateApplicationStatus');
export const getDeleteApplicationStatus = state => get(state, 'application.deleteApplicationStatus');
export const isAddApplicationSuccess = state => get(state, 'application.isAddApplicationSuccess');
export const isUpdateApplicationSuccess = state => get(state, 'application.isUpdateApplicationSuccess');
export const getIsUpdateApplicationCustomFieldsSuccess = state => get(state, 'application.isUpdateApplicationCustomFieldsSuccess');
export const getIsUpdateApplicationCustomFieldsError = state => get(state, 'application.isUpdateApplicationCustomFieldsError');
export const getKeysTotalPages = (state) => get(state, 'application.keys.totalPages');
export const getKeysTotalElements = (state) => get(state, 'application.keys.totalElements');
export const getKeysResults = (state) => get(state, 'application.keys.results');
export const getPublishResult = (state) => get(state, 'application.publishResult');
export const getAppRequestStatus = (state) => get(state, 'application.appRequestStatus');
export const getAppCustomFieldValues = (state) => get(state, 'application.appCustomFieldValues');
export const getCreatedKey = (state) => get(state, 'application.createdKey');
export const getAppAssignedAPIsUpdateResult = (state) => get(state, 'application.appAssignedAPIsUpdateResult');
export const getAppAssignedAPIs = (state) => get(state, 'application.appAssignedAPIs');
export const getIsappAssignedApisFailure = (state) => get(state, 'application.appAssignedAPIsGetFailure');
export const getAppAssignedApiPlansUpdateResult = (state) => get(state, 'application.appAssignedApiPlansUpdateResult');
export const getAppAssignedApiPlans = (state) => get(state, 'application.appAssignedApiPlans');
export const getIsappAssignedApiPlansFailure = (state) => get(state, 'application.appAssignedApiPlansGetFailure');
export const getAppAssignedAPIGroupsUpdateResult = (state) => get(state, 'application.appAssignedAPIGroupsUpdateResult');
export const getAppAssignedAPIGroups = (state) => get(state, 'application.appAssignedAPIGroups');
export const getSingleApiPlan = (state) => get(state, 'application.singleApiPlan');
export const getSingleApiGroup = (state) => get(state, 'application.singleApiGroup');

export const getDeleteKeyErrors = (state) => get(state, 'application.deleteKeyErrors');

export const getApisListTotalPages = (state) => get(state, 'application.apis.totalPages');
export const getApisListTotalElements = (state) => get(state, 'application.apis.totalElements');
export const getApisListResults = (state) => get(state, 'application.apis.results');

export const getIsApiUpdateSuccess = (state) => get(state, 'application.isApiUpdateSuccess');

export const getProductApisListTotalPages = (state) => get(state, 'application.productApis.totalPages');
export const getProductApisListTotalElements = (state) => get(state, 'application.productApis.totalElements');
export const getProductApisListResults = (state) => get(state, 'application.productApis.results');

export const getIsProductApiUpdateSuccess = (state) => get(state, 'application.isProductApiUpdateSuccess');
export const getIsProductApiError = (state) => get(state, 'application.isProductApiError');
export const getProductApiErrors = (state) => get(state, 'application.productApiErrors');

export const getAppProductTiers = (state) => get(state, 'application.appProductTiers');

export const getCertList = (state) => get(state, 'application.certificateList');
export const getCertListError = (state) => get(state, 'application.certListGetError');
export const getAddCertResponse = (state) => get(state, 'applicaiton.certAddResponse');
export const getAddCertStatus = (state) => get(state, 'application.certAddStatus');
export const getCertValidationErrors = (state) => get(state, 'application.certValidationErrors');
export const getCertDeleteStatus = (state) => get(state, 'application.certDeleteStatus');

export const getAllOAuthClients = (state) => get(state, 'application.oAuthClients');
export const getAllOAuthClientsTotalCount = (state) => get(state, 'application.oAuthClients.totalElements');
export const getSingleOAuthClient = (state) => get(state, 'application.oAuthClient');
export const getCreatedOAuthClient = (state) => get(state, 'application.createdOAuthClient');
export const getCreateOAuthClientStatus = (state) => get(state, 'application.oAuthClientCreateStatus');
export const getUpdateOAuthClientStatus = (state) => get(state, 'application.oAuthClientUpdateStatus');
export const getDeleteOAuthClientStatus = (state) => get(state, 'application.oAuthclientDeleteStatus');
export const getOAuthClientErrors = (state) => get(state, 'application.oAuthClientErrors');
